(function ($) { 

  Drupal.behaviors.homeTeaserMatrix = {
	    attach: function (context) {
	    		Drupal.behaviors.homeTeaserMatrixCreator(context);
	    }
  };
  
  Drupal.behaviors.homeTeaserMatrixCreator = function (context){
    $(".home-teaser-matrix", context).each(function (index){    			

        $(this).find(".home-teaser-matrix__blocks").slick({                    
            infinite: false,
            variableWidth: false,
            adaptiveHeight: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            //centerPadding: '48px',
            centerPadding: '80px',
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 992,
                settings: "unslick"
              }
            ]        
        });
        
    });

  }  
  
})(jQuery);
